import React from 'react'

import Flare from '../../../../assets/flare.svg'
import '../../LoyaltyConfirmation.css'

export const LoyaltyRewardsEarned = () => {
  return (
    <div styleName='container'>
      <Flare />
      <h2 styleName='title'>You earned points with this order!</h2>
      <p styleName='description'>Check your email receipt for more details.</p>
    </div>
  )
}
